module.exports = __webpack_public_path__ + "static/img/minicon1.3b798daa.png";